/**
 * orga-app-api - kommunikation-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SmtpMandantOptions { 
    server?: string;
    port?: number;
    user?: string;
    password?: string;
    use_mail_adress_from?: boolean;
    mail_address?: string;
    mail_user_name?: string;
    use_default_value?: boolean;
}

